import { render } from "./CopyrightHengxing.vue?vue&type=template&id=64c023a3&scoped=true"
import script from "./CopyrightHengxing.vue?vue&type=script&lang=js"
export * from "./CopyrightHengxing.vue?vue&type=script&lang=js"

import "./CopyrightHengxing.vue?vue&type=style&index=0&id=64c023a3&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c023a3"]])

export default __exports__